<script lang="ts" setup>
import { useVoipRoomStore } from '../model/voip-room-store'
import LiveKitButtonMic from './livekit/LiveKitButtonMic.vue'

defineOptions({
  name: 'ButtonMic',
})

const voipRoomStore = useVoipRoomStore()
</script>

<template>
  <LiveKitButtonMic
    v-if="voipRoomStore.isLiveKitRoom"
  />
</template>
